// extracted by mini-css-extract-plugin
module.exports = {"regulatoryHeader":"_b958a27"};